module.exports = __webpack_public_path__ + "img/10_financial-wellness.beebaf05.png";